// extracted by mini-css-extract-plugin
export default {"nonprofit-conatiner":"nonprofit_nonprofit-conatiner__DU8aU","nonprofit-image":"nonprofit_nonprofit-image__NlkkT"};